import fetch from 'auth/FetchInterceptor'
import {API_BASE_URL} from '../configs/AppConfig'
const SessionService = {}


SessionService.getSession = function (params) {
	let {page, searchSession} = params;
	let offset = (page-1)*10;
	return fetch({
		url: API_BASE_URL+'/v1/admin/all-session',
		method: 'get',
        params: {
            'offset' : offset,
			searchSession
        }
	})
}; 

SessionService.getSessionWithId = function (id) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/single-session/${id}`,
		method: 'get',

	})
};

SessionService.getSessionPlayer = function (data) {
	let {id, page} = data;

   let offset = (page-1)*10;
  return fetch({
	  url: API_BASE_URL+`/v1/admin/session-player/${id}`,
	  method: 'get',
	  params: {
		  'offset' : offset
	  }
  })
};


export default SessionService;